import { CARRIER_LOGOS_BASE_URL } from '@zorro/common-utils';
import { replaceSpecialCharsInImageUrl } from '@zorro/shared/formatters';

// Some carriers operate under many regional/product names that all share one logo in S3.
// Each pattern maps any matching carrier name to the canonical logo filename.
// e.g. "Delta Dental of California", "Northeast Delta Dental", "DeltaCare USA" → Delta-Dental.png
const CARRIER_LOGO_NAME_PATTERNS: [RegExp, string][] = [
  [/delta dental/iu, 'Delta Dental'],
  [/^deltacare/iu, 'Delta Dental'],
  [/^allstate/iu, 'Allstate Health Solutions'],
];

export const getCarrierLogoUrl = (carrierName?: string): string => {
  if (!carrierName) return '';
  const match = CARRIER_LOGO_NAME_PATTERNS.find(([pattern]) =>
    pattern.test(carrierName)
  );
  const logoName = match ? match[1] : carrierName;
  return `${CARRIER_LOGOS_BASE_URL}/${encodeURIComponent(
    replaceSpecialCharsInImageUrl(logoName)
  )}.png`;
};
